module.exports = __webpack_public_path__ + "img/oliver-e.6b7272bb.png";